module.exports = __webpack_public_path__ + "img/bluedifflevel.38e930e3.svg";